import { Chip } from "@/components/badge/chip";
import type { Prd } from "@/types/domain";

// Kind marker for mixed issue lists (issue unification): red Bug / cyan Doc /
// teal Todo; renders nothing for plain PRDs (the default kind stays unmarked).
export const IssueTypeChip = ({ prd }: { prd: Prd }) =>
  prd.type === "bug" ? (
    <Chip tone="red" className="shrink-0">
      Bug
    </Chip>
  ) : prd.type === "doc" ? (
    <Chip tone="cyan" className="shrink-0">
      Doc
    </Chip>
  ) : prd.type === "todo" ? (
    <Chip tone="teal" className="shrink-0">
      Todo
    </Chip>
  ) : null;

export default IssueTypeChip;
